import { FC } from 'react';
import { DotSpinner } from '@crono-one/design-system';

import PATH from 'crono-fe-common/constants/path';
import useAircallAuthCallback from 'hooks/services/aircall/useAircallAuthCallback';
import { useAnalytics } from 'context/analytics';
import useOauthCallbackCode from 'pages/connect/views/useOauthCallbackCode';

const AircallLoginHandler: FC = () => {
  const analytics = useAnalytics();
  const { mutate: aircallAuthCallback } = useAircallAuthCallback();

  useOauthCallbackCode({
    provider: 'Aircall',
    exchangeCode: aircallAuthCallback,
    buildVariables: (code) => ({ code }),
    missingCodePath: PATH.SETTINGS.INTEGRATIONS.CALL,
    successPath: PATH.SETTINGS.INTEGRATIONS.CALL,
    errorPath: PATH.SETTINGS.INTEGRATIONS.CALL,
    onSuccess: () => {
      analytics?.track('call-integration', {
        type: 'aircall',
      });
    },
  });

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default AircallLoginHandler;
